import { httpToken } from "@/utils/http";
import { cameraDevice } from "@/utils/http";
import qs from 'qs';
// 获取粮权所属数据
const getGrainmanagement = function (type, is) {
  let json = [{ column: "sort", type: 'orderByAsc' }]
  let return_arr = [];
  httpToken({
    method: "post",
    url: "/grain-owned/all",
    data: qs.stringify({
      'paramData': JSON.stringify(json)
    }),
  }).then((res) => {
    let resdata = res.data.data;
    // console.log('getGrainmanagement',resdata)
    for (let i in resdata) {
      if (type == 1) {
        return_arr.push({
          'label': resdata[i].companyName,
          'value': resdata[i].id,
        })
      } else {
        return_arr.push({
          'label': resdata[i].companyName,
          'value': resdata[i].companyName,
        })
      }
    }
    if (is) {
      return_arr.unshift({
        'label': '全部',
        'value': null,
      })
    }
  })
  return return_arr;
}
// 获取所有货位
export function getbarnInfoson(type, is) {
  let json = [{ column: "unit", type: 'eq',value:JSON.parse(sessionStorage.getItem('user')).unitId },{ 'column': "create_date", 'type': "orderByAsc" },]
  return httpToken({
    method: "post",
    url: "/barn-info-son/all",
    data: qs.stringify({
      'paramData': JSON.stringify(json)
    }),
  }).then((res) => {
    let return_arr=res.data.data.map(item=>{
      return {
        label:item.name,
        value:item.id,
        ...item
      }
    })
    if (is) {
      return_arr.unshift({
        'label': '全部',
        'value': null,
      })
    }
    return return_arr
  })
}
// 获取单位下拉 参数等级  is为true时头添加全部
const getunitdata = function (level, type, is) {
  // {'column': "sort", 'type': "orderByAsc"},
  let json = [{ 'column': "level", 'type': "eq", 'value': level }, { 'column': "create_date", 'type': "orderByAsc" },]
  let return_arr = [];
  httpToken({
    method: "post",
    url: "/sys-unit/all",
    data: qs.stringify({
      'paramData': JSON.stringify(json)
    }),
  }).then((res) => {
    let resdata = res.data.data;
    console.log('resdata', resdata)
    for (let i in resdata) {
      if (type == 1) {
        return_arr.push({
          'label': resdata[i].shortName,
          'value': resdata[i].unitCode,
        })
      } else {
        return_arr.push({
          'label': resdata[i].shortName,
          'value': resdata[i].shortName,
        })
      }
    }
    if (is) {
      return_arr.unshift({
        'label': '全部',
        'value': null,
      })
    }
  })
  return return_arr;
}
// 查询所有在使用的货位
export function barnInfoSonAllList(type=1){
  let paramData = [{ column: "unit", type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId }];
  return cameraDevice({
    url: '/barnInfoSon/findAllList',
    method: 'post',
    data: qs.stringify({
      paramData: JSON.stringify(paramData),
    })
  }).then(res => {
    let array = []
    res.data.data.forEach((item) => {
      if(type==1){
        if (item.rtu) {
          array.push( { 'label': item.name, 'value': item, })
        }
      }else{
        array.push(item)
      }
    })
    return array
  })
}
// 获取存在rtu的仓房下拉
export function getbarn_rtuInfo_then(type) {
  let paramData = [{ column: "unit", type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId }];
  return httpToken({
    url: '/barnInfo/allNo',
    method: 'post',
    data: qs.stringify({
      paramData: JSON.stringify(paramData),
    })
  }).then(res => {
    // console.log('获取存在rtu的仓房',res)
    let array = []
    let resdata = res.data.data
    resdata.forEach((item) => {
      if (item.rtu) {
        array.push(item)
      }
    })
    return array
  })
}
// 获取所有虚拟货位下拉
export function getbarn_xnInfo_then(type) {
  let paramData = [{ column: "unit", type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId }]
  return httpToken({
    url: '/dropDown/barnInfo3',
    method: 'post',
    data: qs.stringify({
      paramData: JSON.stringify(paramData),
    })
  }).then(res => {
    // console.log('获取虚拟货位',res)
    let array = []
    let resdata = res.data.data
    if (type == 1) {
      resdata.forEach((item) => {
        if (item.sons !== null) {
          let children = []
          item.sons.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.id })
          })
          array.push({ 'label': item.barName, 'value': item.barNumber, children: children })
        } else {
          array.push({ 'label': item.barName, 'value': item.barNumber, })
        }
      })
    } else {
      array = resdata
    }
    return array
  })
}
// 获取所有磅房下拉
export function getpoundRoom(type = 1) {
  // let paramData = [{column: "unit", type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId}]
  let paramData = []
  return httpToken({
    url: '/poundRoom/all',
    method: 'post',
    data: qs.stringify({
      paramData: JSON.stringify(paramData),
    })
  }).then(res => {
    console.log('获取所有磅房', res)
    let array = []
    let resdata = res.data.data
    if (type == 1) {
      resdata.forEach((item) => {
        array.push({ 'label': item.poundName, 'value': item.unitRemark })
      })
    } else {
      array = resdata
    }
    return array
  })
}
// 获取所有货位下拉
export function getallSonsBarn(type = 1) {
  let paramData = [
    { column: "unit", type: "eq", value: JSON.parse(sessionStorage.getItem('user')).unitId },
    { column: "bar_status", type: "eq", value: '启用' }
  ]
  // if (this.$store.state.Manage.noticesStatus === 1) {
  //   paramData.push({ column: "actual_size", type: "gt", value: 0 })
  // } else if (this.$store.state.Manage.noticesStatus === 0) {
  //   paramData.push({ column: "bar_use_status", type: "ne", value: '满仓' })
  // }
  return httpToken({
    method: "post",
    url: "/barnInfo/allSons",
    data: qs.stringify({ paramData: JSON.stringify(paramData), }),
  }).then((res) => {
    let array = []
    if(type == 1){
      res.data.data.forEach((item) => {
        let children = []
        if (item.sons !== null) {
          item.sons.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.id })
          })
          array.push({ 'label': item.barName, 'value': item.id, children: children })
        } else {
          array.push({ 'label': item.barName, 'value': item.id, })
        }
      })
    }else if(type == 2){
      res.data.data.forEach((item) => {
        let children = []
        if (item.sons !== null) {
          item.sons.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.name+'#_#'+item2.id })
          })
          array.push({ 'label': item.barName, 'value': item.name+'#_#'+item.id, children: children })
        } else {
          array.push({ 'label': item.barName, 'value': item.name+'#_#'+item.id, })
        }
      })
    }
    return array
  });
}
// 获取所有用户下拉
export function getsysUser(type = 1) {
  let paramData = [{ column: "unit_id", type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId }]
  return httpToken({
    url: '/sys-user/all',
    method: 'post',
    data: qs.stringify({
      paramData: JSON.stringify(paramData),
    })
  }).then(res => {
    // console.log('获取所有用户',res)
    let array = []
    let resdata = res.data.data
    if (type == 1) {
      resdata.forEach((item) => {
        array.push({ 'label': item.chnname, 'value': item.id })
      })
    } else if (type == 2) {
      resdata.forEach((item) => {
        array.push({ 'label': item.chnname, 'value': item.chnname })
      })
    } else {
      array = resdata
    }
    return array
  })
}
//获取所有地磅数据
export function getPoundRoom(type = 1) {
  return httpToken({
    url: '/poundRoom/all',
    method: 'post',
  }).then(res => {
    // console.log('获取所有地磅数据',res.data.data)
    if (type == 1) {
      res.data.data.forEach((item) => {
        item.value = item.poundName
      })
    }
    return res.data.data
  })
}
// 获取摄像头下拉
export function getCamera(type = 1) {
  // let paramData = [{column: "unit", type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId}]
  let paramData = [
    { column: "granaryCode", type: 'eq', value: JSON.parse(sessionStorage.user).unitId },
    { column: "sortId", type: 'orderByAsc' }
  ];
  return cameraDevice({
    url: '/cameradevice/findAllByData',
    method: 'post',
    data: qs.stringify({
      paramData: JSON.stringify(paramData),
    })
  }).then(res => {
    // console.log('获取所有摄像头',res)
    let array = []
    let resdata = res.data.data
    if (type == 1) {
      resdata.forEach((item) => {
        array.push({ 'label': item.name, 'value': item.id })
      })
    } else {
      array = resdata
    }
    return array
  })
}
// 获取产地区域下拉数据
export function getisOwncountryData(){
  return [
    { label: '国内', value: 0 },
    { label: '国外', value: 1 },
  ]
}
// 包装方式下拉数据
export function getpacking() {
  return [
    { 'label': '麻袋', 'value': 1 },
    { 'label': '编织袋', 'value': 2 },
    { 'label': '散装', 'value': 3 },
    { 'label': '其他', 'value': 9 },
  ]
}
// 扦样方式下拉数据
export function getsample() {
  return [
    { 'label': '人工', 'value': 0 },
    { 'label': '自动', 'value': 1 },
    { 'label': '智能随机', 'value': 2 },
  ]
}
// 获取扦样方式
export function setsample(value) {
  let str = ''
  switch (Number(value)) {
    case 0: str = '人工'
      break
    case 1: str = '自动'
      break
    case 2: str = '智能随机'
      break
    default:
      str = '未知'
      break
  }
  return str
}
// 结算方式下拉数据
export function getSettlement() {
  return [
    { 'label': '现金', 'value': 0 },
    { 'label': '转账', 'value': 1 },
  ]
}
// 获取结算方式
export function setSettlement(value) {
  let str = ''
  switch (Number(value)) {
    case 0: str = '现金'
      break
    case 1: str = '转账'
      break
    default:
      str = '未知'
      break
  }
  return str
}
// 车牌地区号
export function getcarNumber() {
  return [{ value: '辽' }, { value: '吉' }, { value: '黑' }, { value: '浙' }, { value: '京' }, { value: '沪' }, { value: '苏' }, { value: '粤' }, { value: '鲁' }, { value: '晋' }, { value: '冀' }, { value: '豫' }, { value: '渝' }, { value: '皖' }, { value: '鄂' }, { value: '津' }, { value: '贵' }, { value: '云' }, { value: '桂' }, { value: '琼' }, { value: '青' }, { value: '新' }, { value: '藏' }, { value: '蒙' }, { value: '宁' }, { value: '甘' }, { value: '川' }, { value: '陕' }, { value: '闽' }, { value: '赣' }, { value: '湘' }]
}
// 银行行别代码下拉数据
export function getBankline() {
  return [
    { 'label': '中国工商银行', 'value': 102 },
    { 'label': '中国农业银行', 'value': 103 },
    { 'label': '中国银行', 'value': 104 },
    { 'label': '中国建设银行', 'value': 105 },
    { 'label': '中国农业发展银行', 'value': 203 },
    { 'label': '农村商业银行', 'value': 314 },
    { 'label': '农村信用合作社', 'value': 402 },
    { 'label': '中国邮政储蓄', 'value': 403 },
    { 'label': '其他银行', 'value': 999 },
  ]
}
// 获取结算方式
export function setBankline(value) {
  let str = ''
  switch (Number(value)) {
    case 102: str = '中国工商银行'
      break
    case 103: str = '中国农业银行'
      break
    case 104: str = '中国银行'
      break
    case 105: str = '中国建设银行'
      break
    case 203: str = '中国农业发展银行'
      break
    case 314: str = '农村商业银行'
      break
    case 402: str = '农村信用合作社'
      break
    case 403: str = '中国邮政储蓄'
      break
    case 999: str = '其他银行'
      break
    default:
      str = '未知'
      break
  }
  return str
}
// 业务类型下拉数据
export function getnoticeTypeList() {
  return [
    { 'label': '收购业务', 'value': 0 },
    { 'label': '非收购业务', 'value': 1 },
  ]
}
//获取所有合同数据
export function getContract(type = 1) {
  return httpToken({
    url: '/contract/all',
    method: 'post',
  }).then(res => {
    if (type == 1) {
      res.data.data.forEach((item) => {
        item.label = item.htmc,
        item.value = item.id
      })
    }
    return res.data.data
  })
}
//获取所有国家下拉数据
export function getCountry(type = 1) {
  return httpToken({
    url: '/country/all',
    method: 'post',
  }).then(res => {
    if (type == 1) {
      res.data.data.forEach((item) => {
        item.label = item.chineseShort,
        item.value = item.chineseShort
      })
    }
    return res.data.data
  })
}
//获取所有通知单下拉数据
export function getNotice(type = 1) {
  return httpToken({
    url: '/group-notice/all',
    method: 'post',
  }).then(res => {
    if (type == 1) {
      res.data.data.forEach((item) => {
        item.label = item.number,
        item.value = item.id
      })
    }
    return res.data.data
  })
}
export {
  getGrainmanagement, getunitdata
}